import { Menu } from "antd";
import { Route, Routes, useParams, useNavigate } from "react-router-dom";
import ContentLayout from "../../layout/ContentLayout";
import Billing from "./Billing";
import Settings from "./Settings";
import Usage from "./Usage";
import Users from "./Users";

const Organization = () => {
  const { organizationId } = useParams();
  const items = [
    { label: "Usage", key: "" },
    { label: "Users", key: "users" },
    { label: "Billing", key: "billing" },
    { label: "Settings", key: "settings" },
  ];

  const navigate = useNavigate();

  const menuClick = (item) => {
    const { key } = item;
    navigate(key);
  };

  return (
    <>
      <div className="sub-menu">
        <Menu items={items} onClick={menuClick} mode="horizontal" />
      </div>
      <ContentLayout>
        <Routes>
          <Route
            path="/settings"
            element={<Settings organizationId={organizationId} />}
          />
          <Route
            path="/"
            index
            element={<Usage organizationId={organizationId} />}
          />
          <Route
            path="/users"
            element={<Users organizationId={organizationId} />}
          />
          <Route
            path="/billing"
            element={<Billing organizationId={organizationId} />}
          />
        </Routes>
      </ContentLayout>
    </>
  );
};

export default Organization;
